module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/169f7755a820bb597640f838ccc34af6.png";